import { LOAD_ABOUT_DATA_SUCCESS, LOAD_HOME_DATA_SUCCESS } from './actions';
import { createSelector } from 'reselect';
import { GlobalState } from '../rootReducer';

// reducer
const DEFAULT_STATE = {
    trustMetrics: {},
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOAD_ABOUT_DATA_SUCCESS:
        case LOAD_HOME_DATA_SUCCESS:
            return {
                ...state,
                trustMetrics: { ...action.payload.siteStatistics },
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.trustMetrics;

export const trustMetricsSelector = createSelector(stateSelector, (state) => state.trustMetrics);
